import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { onboardingKeys } from "@/lib/query-keys";
import type { MyCompanyDocumentsState, OnboardingQualification } from "@/types/domain";

/**
 * Los documentos que sube en el onboarding. Mientras la IA lee alguno se
 * pregunta seguido: tarda de 30 s a un minuto y está mirando la pantalla.
 */
export function useOnboardingDocuments(enabled = true) {
  return useQuery<MyCompanyDocumentsState>({
    queryKey: onboardingKeys.documents(),
    enabled,
    queryFn: () => fetchToBackend("/onboarding/documents"),
    refetchInterval: (query) =>
      query.state.data?.unreadDocuments.some((doc) => doc.state === "PROCESSING")
        ? 4000
        : false,
  });
}

/** El cruce de prueba: se consulta seguido mientras lee documentos o cruza obras. */
export function useOnboardingQualification(enabled = true) {
  return useQuery<OnboardingQualification>({
    queryKey: onboardingKeys.qualification(),
    enabled,
    queryFn: () => fetchToBackend("/onboarding/qualification"),
    refetchInterval: (query) =>
      query.state.data?.phase === "reading" || query.state.data?.phase === "crossing"
        ? 3000
        : false,
  });
}
